module.exports = __webpack_public_path__ + "8c090bc78f97f2bdc6e961e0ea5f6c0e.svg";